var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{attrs:{"id":_vm.id}}),_vm._v(" "),_c('insert-label-dialog',{ref:"dialog",on:{"select":_vm.onLabelSelect}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }